export interface GraphNode {
  id: string;
  x: number;
  y: number;
  vx: number;
  vy: number;
  size: number;
  locked: boolean;
  parentId: string | null;
  label: string;
  type: 'idea' | 'text' | 'image' | 'url' | 'universe' | 'doc';
  category: 'strategy' | 'idea' | 'execution';
  color: string;
  icon?: string;
  content?: string; // legado; após migração para Tiptap vira referência ao doc
  // Âncora da posição "de descanso": o wave oscila ao redor dela e o nó sempre
  // retorna. Atualizada quando o usuário solta um drag. Volátil (não persiste).
  homeX?: number;
  homeY?: number;
  // Posição no fim do último tick — detecta teleporte externo. Volátil.
  prevX?: number;
  prevY?: number;
}

export interface GraphLink {
  id: string;
  source: string;
  target: string;
  type: 'synapse' | 'wiki';
  strength: number;
}

export interface DragState {
  id: string;
  dx: number;
  dy: number;
  moved: boolean;
}

export interface PhysicsConfig {
  coulombStrength: number; // default 6200
  coulombMaxForce: number; // default 10
  springRest: number; // default 320
  springK: number; // default 0.005
  plasticThreshold: number; // default 450
  centerGravityRadius: number; // default 400
  centerGravityFade: number; // default 700
  centerGravityK: number; // default 0.00006
  damping: { near: number; far: number; threshold: number };
  maxVelocity: { near: number; far: number; threshold: number };
  boundary: number; // default 3000
  // Barnes-Hut theta — quanto maior, mais aproximação (mais rápido).
  barnesHutTheta: number; // default 0.8; 0 = exato O(n²)
  // Spring de retorno à âncora (homeX/homeY). Mantém o wave oscilando ao redor
  // da posição original em vez de deixar o nó derivar.
  anchorK: number; // default 0.015
}

export const DEFAULT_PHYSICS: PhysicsConfig = {
  coulombStrength: 6200,
  coulombMaxForce: 10,
  springRest: 320,
  springK: 0.005,
  plasticThreshold: 450,
  centerGravityRadius: 400,
  centerGravityFade: 700,
  centerGravityK: 0.00006,
  damping: { near: 0.898, far: 0.65, threshold: 500 },
  maxVelocity: { near: 6.0, far: 1.0, threshold: 500 },
  boundary: 3000,
  barnesHutTheta: 0.8,
  anchorK: 0.015,
};
